/**
* SideNavController
* @namespace gplans.layout.controllers
*/
(function () {
  'use strict';SideNavController.$inject = ["$rootScope", "$location", "$analytics", "$uibModal", "Authentication", "Profile", "Mealplan", "$state", "$window", "TempCheckin", "UserService"];

  angular.
  module('gplans.layout.controllers').
  controller('PauseModalInstanceCtrl', ["$rootScope", "$uibModalInstance", function ($rootScope, $uibModalInstance) {
    var vm = this;
    vm.cancel = cancel;
    vm.confirm = confirm;

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function confirm() {
      $uibModalInstance.close('ok');
    }
  }]).
  controller('SideNavController', SideNavController);

  SideNavController.$inject = ['$rootScope', '$location', '$analytics', '$uibModal', 'Authentication', 'Profile', 'Mealplan', '$state', '$window', 'TempCheckin', 'UserService'];

  /**
                                                                                                                                                                                   * @namespace SideNavController
                                                                                                                                                                                   */
  function SideNavController($rootScope, $location, $analytics, $uibModal, Authentication, Profile, Mealplan, $state, $window, TempCheckin, UserService) {
    var vm = this;
    vm.pausePlan = pausePlan;
    vm.resetWeek = resetWeek;
    vm.isActive = isActive;

    /**
                             * @name isActive
                             * @desc
                             * @memberOf gplans.layout.controllers.SideNavController
                             */
    function isActive(viewLocation) {
      return viewLocation === $location.path();
    }

    /**
       * @name pausePlan
       * @desc pauses user week plan until he's ready to follow up
       * TODO: encapsulate to a separate service along with unpause function
       * @memberOf gplans.layout.controllers.SideNavController
       */
    function pausePlan() {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'md',
        templateUrl: 'pauseModalContent.html',
        controller: 'PauseModalInstanceCtrl',
        controllerAs: 'vm' });


      modalInstance.result.then(function (res) {
        // TODO: reset checkin!
        // reset checkin if we're not on day 1
        if (UserService.data.last_checkin.day != 1) {
          var oCheckin = {
            weight: UserService.data.current_weight,
            hips: UserService.data.last_checkin.hips,
            waist: UserService.data.last_checkin.waist,
            prior_week_success: 0 };

          TempCheckin.createCheckin(oCheckin);
        }

        // we both create and update since we don't have createOrUpdate
        // TODO: createOrUpdate – in 1 api request, http://stackoverflow.com/questions/37833307/django-rest-framework-post-update-if-existing-or-create
        Profile.updateMisc({ key: 'mealPlanPaused', value: UserService.data.last_checkin.day }).
        then(pauseSuccessFn,
        function (err) {
          console.log(err);
          Profile.createMisc({ key: 'mealPlanPaused', value: UserService.data.last_checkin.day }).
          then(pauseSuccessFn, pauseErrorFn);
        });

        function pauseSuccessFn(res) {
          $rootScope.mealPlanPaused = res.data.value > 0;
          $analytics.eventTrack('Pause Plan');
        }

        function pauseErrorFn(err) {
          console.log(err);
        }

        $rootScope.suppressLoader = 0;
      }, function (res) {
        // cancel
      })['finally'](function () {
        // we should null modal in case we want open it again
        modalInstance = undefined;
      });
    }

    function resetWeek() {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'md',
        templateUrl: 'resetWeekModalContent.html',
        controller: 'PauseModalInstanceCtrl',
        controllerAs: 'vm' });


      modalInstance.result.then(function (res) {
        var checkinData = {};
        checkinData.weight = UserService.data.last_checkin.weight;
        TempCheckin.createCheckin(checkinData).then(function (res) {
          $state.go('gplans.userConsole', {}, { reload: true });
        });
      }, function (res) {
        // cancel
      })['finally'](function () {
        // we should null modal in case we want open it again
        modalInstance = undefined;
      });
    }

  }
})();